import React, { useEffect, useRef, useState } from 'react'
import './org-dashboard.scss'

/**
 * One polite live region for the whole page. It speaks when loading starts and when it finishes, not on every
 * render, and is empty on a page that was never loading.
 */
export const LoadingAnnouncement: React.FC<{ loading: boolean }> = ({ loading }) => {
    const [announcement, setAnnouncement] = useState('')
    const wasLoading = useRef(false)
    useEffect(() => {
        if (loading) setAnnouncement('Loading dashboard')
        else if (wasLoading.current) setAnnouncement('Dashboard updated')
        wasLoading.current = loading
    }, [loading])
    return (
        <div className="sr-only org-dashboard-live-announcement" role="status" aria-live="polite">
            {announcement}
        </div>
    )
}
